module.exports = __webpack_public_path__ + "img/43.8f68e68e.webp";